module.exports = __webpack_public_path__ + "static/media/23.4d6007df.JPG";